import { gql } from '@apollo/client';
import { Product } from '@interfaces';

export const lastPurchasesQuery = () => gql`
  query lastOrdersPurchasesQuery {
    lastOrdersPurchases {
      product {
        id
        uuid
        name
        tradename
        makerBrand
        slug
        concentration
        imagesUrl
        laboratory
        activePrinciple
        unit
        quantity
        thumbnailUrl
        price
        discount {
          price
          type
          stockRestriction
          dateRestriction
          listPrice
        }
        prescriptionType
        availability {
          status
          statusWithoutStock
          stock
          discountStock
        }
        categories {
          id
          name
        }
        isCheapestActivePrinciple
      }
      orderId
    }
  }
`;

export type LastPurchasesQueryResponse = {
  lastOrdersPurchases: { product: Product; orderId: number }[];
};
